import {
  Calendar, Target, Clock, Trophy, Info, XCircle, StickyNote, UserCheck, UserX,
} from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const OUTCOME_TYPES = [
  { key: 'will_refer',         label: 'Will refer',           icon: UserCheck,  askPotential: true,  requireRating: true, cooldown: '30 days' },
  { key: 'meeting_set_up',     label: 'Meeting set up',       icon: Calendar,   askMeeting: true,   cooldown: 'Until meeting date' },
  { key: 'meeting_result',     label: 'Meeting result',       icon: Target,     askReferralsReceived: true, cooldown: '14 days' },
  { key: 'call_back_later',    label: 'Call back later',      icon: Clock,      askFollowup: true,  cooldown: 'Until follow-up date' },
  { key: 'converted',          label: 'Converted',            icon: Trophy,      cooldown: '30 days' },
  { key: 'wants_more_info',    label: 'Wants more info',      icon: Info,        cooldown: 'Stays in queue — cold on 2nd day with no response' },
  { key: 'no_response',        label: 'No response',          icon: XCircle,     cooldown: 'Leaves today\'s queue, back tomorrow — cold on 2nd day with no response' },
  { key: 'note',               label: 'Note only',            icon: StickyNote,  cooldown: 'Stays in queue — cold on 2nd day with no response' },
  { key: 'not_interested',     label: 'Not interested',       icon: XCircle,     cooldown: 'Permanent' },
  { key: 'wont_refer_dormant', label: 'Won\'t refer — dormant', icon: UserX,     markDormant: true, cooldown: 'Dormant' },
];

const OUTCOME_LABELS = Object.fromEntries(OUTCOME_TYPES.map(o => [o.key, o.label]));
OUTCOME_LABELS['email_sent'] = 'Email sent';
export const outcomeLabel = (key) => OUTCOME_LABELS[key] || key;

// XHR helper (fetch is avoided for mutations due to proxy constraints)
export const xhrJson = (method, path, body, onDone) => {
  const xhr = new XMLHttpRequest();
  xhr.open(method, `${API}${path}`, true);
  const t = localStorage.getItem('session_token') || sessionStorage.getItem('session_token');
  if (t) xhr.setRequestHeader('Authorization', `Bearer ${t}`);
  if (body) xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.onload = () => {
    let data = null;
    try { data = JSON.parse(xhr.responseText); } catch { /* empty */ }
    onDone(xhr.status, data);
  };
  xhr.onerror = () => onDone(0, null);
  xhr.send(body ? JSON.stringify(body) : null);
};
